import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import classNames from 'classnames';

const Icon = ({name, className = '', buttonClassName = '', buttonStyle = {}, size = '', type = '', label, iconStyle = {}, iconSize = '1x', color, spin = false, bordered = true, ...props}) => {
	if (_.isNumber(size)) {
		iconStyle = {
			...iconStyle,
			fontSize: size,
		};
	}

	let icon = <i
		className={classNames(className, name, size ? `font-size-${size}` : '', color ? `text-${color}` : '', {
			spin: spin,
		})}
		style={{...iconStyle, color}}
		{...props}
	/>;

	if (type === 'fa') {
		icon = <FontAwesomeIcon icon={name} className={classNames('fa-fw', className)} size={iconSize} style={{...iconStyle, color}}/>;
	}

	return icon;
};

Icon.propTypes = {
	name: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	className: PropTypes.string,
	size: PropTypes.number,
	onPress: PropTypes.func,
	iconStyle: PropTypes.object,
	spin: PropTypes.bool,
	bordered: PropTypes.bool,
};

export default Icon;
